import { motion } from "framer-motion";

const MenuToggle = ({ isOpen, toggle, lineColor = "bg-black" }) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle();
  };

  return (
    <button
      onClick={handleClick}
      className="group relative z-[100] flex h-14 w-14 flex-col items-center justify-center gap-[6px] rounded-full hover:bg-[#4169E1]/20 transition-colors duration-300 cursor-pointer touch-none"
      aria-label="Toggle menu"
    >
      {/* Top Line */}
      <motion.span
        className={`block h-[3px] w-8 rounded-full ${lineColor} group-hover:bg-[#4169E1] transition-colors`}
        animate={isOpen ? { rotate: 45, y: 4.5 } : { rotate: 0, y: 0 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
      />

      {/* Bottom Line - Half Width */}
      <motion.span
        className={`block h-[3px] rounded-full ${lineColor} group-hover:bg-[#4169E1] transition-colors -ml-3`}
        animate={
          isOpen
            ? { width: 32, rotate: -45, y: -4.5, x: 8 }
            : { width: 20, rotate: 0, y: 0, x: 0 }
        }
        transition={{ duration: 0.3, ease: "easeInOut" }}
      />
    </button>
  );
};

export default MenuToggle;
